module.exports = __webpack_public_path__ + "img/emoji_02.679eb58e.png";